import { AppIcon } from '@shared-ui/components/ui/app-icon'
import { GText } from '@shared-ui/components/ui/text'
import { useClipboard } from '@shared-ui/platform/hooks/use-clipboard'
import { Pressable, type StyleProp, View, type ViewStyle } from 'react-native'
import { useCreateStyles } from './styles'

export type CardDetailsFieldProps = {
  label: string
  value: string
  isCopyVisible?: boolean
  style?: StyleProp<ViewStyle>
  testID?: string
}

export function CardDetailsField({ label, value, isCopyVisible = true, style, testID }: CardDetailsFieldProps) {
  const styles = useCreateStyles()
  const { handleCopy } = useClipboard()
  return (
    <View testID={testID} style={[styles.root, style]}>
      <View style={styles.content}>
        <GText variant="caption-13-regular" isSecondary>
          {label}
        </GText>
        <GText variant="body-16-medium" numberOfLines={1}>
          {value}
        </GText>
      </View>
      {isCopyVisible && (
        <Pressable
          accessibilityRole="button"
          accessibilityLabel={label}
          onPress={handleCopy(value)}
          style={styles.copy}
        >
          <AppIcon icon="copy-stroke" size={24} isSecondary />
        </Pressable>
      )}
    </View>
  )
}
